import React from 'react'

import * as styles from 'modules/resultsV2/ResultFailureAlert.styles'
import { DataAccessRequestReviewSubStatus, DataAccessRequestStatus } from 'services/data-access-requests/enums'
import type { DataAccessRequestVerificationDetail } from 'services/data-access-requests/types'

interface DataAccessRequestFailureAlertProps {
  dataAccessRequest: DataAccessRequestVerificationDetail
}

export const DataAccessRequestFailureAlert = ({
  dataAccessRequest
}: DataAccessRequestFailureAlertProps): JSX.Element | null => {
  if (dataAccessRequest.status !== DataAccessRequestStatus.Rejected) {
    return null
  }

  const rejectionReason = dataAccessRequest.rejectionReason?.trim()
  const isAdditionalInformationRequired =
    dataAccessRequest.reviewSubStatus === DataAccessRequestReviewSubStatus.AdditionalInformationRequired

  const message = (() => {
    if (isAdditionalInformationRequired) {
      return rejectionReason
        ? `Additional information was requested with a note: "${rejectionReason}"`
        : 'Additional information was requested for this data access request.'
    }

    return rejectionReason ? `The request was rejected with a note: "${rejectionReason}"` : 'The request was rejected.'
  })()

  return (
    <styles.StyledAlert type="danger" showIcon data-testid="rejected-alert">
      {message}
    </styles.StyledAlert>
  )
}
